module.exports = __webpack_public_path__ + "static/img/jj.3a7d8849.png";